import React from 'react';

export default function MailDocumentIcon({ className = '', title }) {
  return (

<svg
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      className={className}
    >
      <path
        d="M0.666667 23H19.3333C19.7015 23 20 22.6983 20 22.3262V10.1973C20 9.82513 19.7015 9.52344 19.3333 9.52344H13.2668C13.1383 8.88043 12.8264 8.28934 12.357 7.81488C12.0967 7.55173 11.6745 7.55177 11.4142 7.81492C11.1538 8.07808 11.1539 8.50474 11.4142 8.76785C11.6288 8.98478 11.7885 9.24241 11.8865 9.52344H8.11409C8.27724 9.05652 8.60751 8.65851 9.05391 8.41566C10.0336 7.88271 10.6667 6.71654 10.6667 5.4448V5.24207C11.4508 4.87968 12 3.89014 12 2.69531C12 1.18392 11.1215 0 10 0C8.87853 0 8 1.18392 8 2.69531C8 3.89014 8.54924 4.87968 9.33333 5.24207V5.4448C9.33333 6.2034 8.95858 6.93706 8.422 7.22896C7.53902 7.70931 6.92893 8.55443 6.73387 9.52344H0.666667C0.298489 9.52344 0 9.82513 0 10.1973V22.3262C0 22.6983 0.298489 23 0.666667 23ZM10 1.34766C10.2718 1.34766 10.6667 1.87266 10.6667 2.69531C10.6667 3.51797 10.2718 4.04297 10 4.04297C9.72818 4.04297 9.33333 3.51797 9.33333 2.69531C9.33333 1.87266 9.72818 1.34766 10 1.34766ZM1.33333 21.6523V12.8543L9.61249 18.8315C9.84436 18.9989 10.1556 18.9989 10.3875 18.8315L18.6667 12.8543V21.6523H1.33333ZM11.8853 10.8711C11.6101 11.6554 10.8691 12.2188 10 12.2188C9.63182 12.2188 9.33333 12.5204 9.33333 12.8926C9.33333 13.2647 9.63182 13.5664 10 13.5664C11.6098 13.5664 12.9565 12.4071 13.2663 10.8711H18.6667V11.1982L10 17.4551L1.33333 11.1982V10.8711H11.8853Z"
        fill="currentColor"
      />
    </svg>

  );
}

